var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12366_46926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 7.49219H15V4.49219C15 3.39219 14.1 2.49219 13 2.49219H11C9.9 2.49219 9 3.39219 9 4.49219V7.49219H4C2.9 7.49219 2 8.39219 2 9.49219V20.4922C2 21.5922 2.9 22.4922 4 22.4922H20C21.1 22.4922 22 21.5922 22 20.4922V9.49219C22 8.39219 21.1 7.49219 20 7.49219ZM11 4.49219H13V9.49219H11V4.49219ZM7 16.4922H6C5.45 16.4922 5 16.0422 5 15.4922C5 14.9422 5.45 14.4922 6 14.4922H7V13.4922C7 12.9422 7.45 12.4922 8 12.4922C8.55 12.4922 9 12.9422 9 13.4922V14.4922H10C10.55 14.4922 11 14.9422 11 15.4922C11 16.0422 10.55 16.4922 10 16.4922H9V17.4922C9 18.0422 8.55 18.4922 8 18.4922C7.45 18.4922 7 18.0422 7 17.4922V16.4922ZM13.75 14.9922C13.34 14.9922 13 14.6522 13 14.2422C13 13.8322 13.34 13.4922 13.75 13.4922H18.25C18.66 13.4922 19 13.8322 19 14.2422C19 14.6522 18.66 14.9922 18.25 14.9922H13.75ZM13.75 17.9922C13.34 17.9922 13 17.6522 13 17.2422C13 16.8322 13.34 16.4922 13.75 16.4922H16.25C16.66 16.4922 17 16.8322 17 17.2422C17 17.6522 16.66 17.9922 16.25 17.9922H13.75Z",
    fill: "#2C2C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12366_46926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.492188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthInfo);
export default __webpack_public_path__ + "static/media/health_info.f829bd41ebd03951cc4a59505e2f9298.svg";
export { ForwardRef as ReactComponent };